"use client";

import Image from "next/image";
import { Link } from "@/navigation";
import { useTranslations } from "next-intl";

const IMAGE_BASE_PATH = "/image/new-version/machining/five-axis/bmcl";

const SURFACE_FINISHES = [
	{ key: "naturalGloss", image: "natural-gloss.webp" },
	{ key: "matte", image: "matte.webp" },
	{ key: "electropolish", image: "electropolish.webp" },
	{ key: "electrophoresis", image: "electrophoreses.webp" },
	{ key: "chromeplate", image: "chromeplate.webp" },
	{ key: "goldPlating", image: "gold-plating.webp" },
	{ key: "blackOxide", image: "black-oxide.webp" },
	{ key: "blackGlossy", image: "black-glossy.webp" },
	{ key: "polishRedCopper", image: "polish-red-copper.webp" },
	{ key: "goldChromate", image: "gold-chromate.webp" },
	{ key: "carbonization", image: "carbonization.webp" },
	{ key: "hardenOxide", image: "harden-oxide.webp" },
];

const AxisBmcl = () => {
	const t = useTranslations("fiveAxisSurfaceFinishes");
	const tMilling = useTranslations("cncMillingBanner");

	return (
		<section className="w-full bg-[#ededed] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="mb-6 flex flex-col gap-3 text-center sm:mb-8 sm:gap-4 md:mb-10 lg:mb-12">
					<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						{tMilling("surfaceFinishesTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">
						{tMilling("surfaceFinishesSubtitle")}
					</p>
				</div>

				<div className="grid grid-cols-2 gap-0 md:grid-cols-3 lg:grid-cols-4">
					{SURFACE_FINISHES.map((finish) => (
						<div key={finish.key} className="flex flex-col border border-[#bfbfbf] p-4 md:p-10">
							<h3 className="mb-3 text-lg font-bold text-black sm:text-xl md:text-2xl">
								{t(`${finish.key}Title` as any)}
							</h3>
							<div className="relative mb-4 aspect-square w-full overflow-hidden">
								<Image
									src={`${IMAGE_BASE_PATH}/${finish.image}`}
									alt={t(`${finish.key}Title` as any)}
									fill
									className="object-contain"
									sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw"
								/>
							</div>
							<p className="text-sm leading-relaxed text-black md:text-base">
								{t(`${finish.key}Desc` as any)}
							</p>
						</div>
					))}
				</div>

				<div className="mt-12 flex justify-center md:mt-16">
					<Link
						href="/surface-finishing"
						className="inline-flex items-center justify-center rounded bg-themePrimary400 px-6 py-3 text-sm font-medium text-white transition-all duration-300 hover:bg-[#5a9420] hover:text-white md:px-8 md:py-3.5 md:text-base"
					>
						{t("moreButton")}
					</Link>
				</div>
			</div>
		</section>
	);
};

export default AxisBmcl;
